/**
 * Platform Admin — semantic design tokens via CSS variables.
 * Values resolve inside `.pf-shell` (see `platform-shell.css`) from the
 * shared tenant theme (`data-theme` on `<html>`, `vistoera-theme` in
 * localStorage). Do not hardcode light-only hex here.
 */

export const platformColors = {
  pageBackground: 'var(--pf-page-bg)',
  surface: 'var(--pf-surface)',
  sidebarBackground: 'var(--pf-sidebar-bg)',
  sidebarBackgroundActive: '#152a40',
  primaryText: 'var(--pf-primary-text)',
  secondaryText: 'var(--pf-secondary-text)',
  mutedText: 'var(--pf-muted-text)',
  border: 'var(--pf-border)',
  primary: 'var(--pf-primary)',
  primaryHover: 'var(--pf-primary-hover)',
  primarySoft: 'var(--pf-primary-soft)',
  sidebarText: 'var(--pf-sidebar-text)',
  sidebarTextMuted: 'var(--pf-sidebar-text-muted)',
  sidebarActiveBg: 'var(--pf-sidebar-active-bg)',
  badgeAmberText: 'var(--pf-badge-amber-text)',
  badgeAmberBg: 'var(--pf-badge-amber-bg)',
  badgeAmberBorder: 'var(--pf-badge-amber-border)',
  success: 'var(--pf-success)',
  successBg: 'var(--pf-success-bg)',
  danger: 'var(--pf-danger)',
  dangerBg: 'var(--pf-danger-bg)',
  info: 'var(--pf-info)',
  infoBg: 'var(--pf-info-bg)',
  warning: 'var(--pf-warning)',
  warningBg: 'var(--pf-warning-bg)',
} as const

export const platformFontFamily =
  'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", "Noto Sans SC", sans-serif'

export const cardIconBg = {
  tenant: 'var(--pf-card-icon-tenant)',
  site: 'var(--pf-card-icon-site)',
  domain: 'var(--pf-card-icon-domain)',
  worker: 'var(--pf-card-icon-worker)',
  task: 'var(--pf-card-icon-task)',
  storage: 'var(--pf-card-icon-storage)',
} as const
